module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/is-pure.js
// module id = 42
// module chunks = 48